import { IEvaluationService } from "../../service/evaluation/EvaluationService";

export default class GetEvaluationsInteractor {
  private evaluationService: IEvaluationService;

  constructor(evaluationService) {
    this.evaluationService = evaluationService;
  }

  async execute(formVersionId: number) {
    return this.evaluationService.getFormEvaluations(formVersionId);
  }
}
